import axios from 'axios';

const apiCosmos = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_brasilapi,
});

const buscaPorCNPJ = async (cnpj) => {
  try {
    const response = await apiCosmos.get(`${cnpj}`, {
      
    });
    // Extrai apenas os campos desejados da resposta
    const {
      razao_social,
      nome_fantasia,
      cnpj: responseCnpj, // Renomeia para evitar conflito com o parâmetro da função
      bairro,
      municipio,
      descricao_tipo_de_logradouro,
      logradouro,
      numero,
      uf,
      cep,
    } = response.data;

    return { razao_social, nome_fantasia, cnpj: responseCnpj, bairro, municipio, descricao_tipo_de_logradouro, logradouro, numero, uf, cep };
  } catch (error) {
    console.error("Erro ao buscar dados do CNPJ:", error.response ? (error.response.data.message || error.response.data.error) : error.message);
    throw error;
  }
};

export default buscaPorCNPJ;